<template>
  <div class="dashboard">
    <div class="dashboard__container">
      <div class="dashboard__row--full">
        <system-info :loads="loads" :status="status"></system-info>
      </div>

      <div class="dashboard__row--full">
        <basic-stats></basic-stats>
      </div>

      <div class="dashboard__row--full">
        <hourly-stats></hourly-stats>
      </div>

      <div class="dashboard__row--full">
        <daily-stats></daily-stats>
      </div>

      <div class="dashboard__row-wrapper">
        <div class="dashboard__row--half">
          <monthly-stats></monthly-stats>
        </div>
        <div class="dashboard__row--half">
          <week-activity-stats></week-activity-stats>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
export default {
  data () {
    return {
      loadsIntervalId: null,
      loads: null,
      status: null
    }
  },

  async created () {
    try {
      await this.updateSystemStatus()
      await this.updateSystemLoads()
      this.loadsIntervalId = setInterval(this.updateSystemLoads, 10000)
      this.statusIntervalId = setInterval(this.updateSystemStatus, 30000)
    } catch (e) {
      console.error(e)
    }
  },

  beforeDestroy () {
    clearInterval(this.loadsIntervalId)
    clearInterval(this.statusIntervalId)
  },

  methods: {
    async updateSystemLoads () {
      try {
        const statusReq = await axios.get('/api/system/system-status')
        this.loads = statusReq.data.status
      } catch (e) {
        console.error(e)
      }
    },

    async updateSystemStatus () {
      try {
        const statusReq = await axios.get('/api/system/services-status')
        this.status = statusReq.data.status
      } catch (e) {
        this.status = null
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &__container {
    width: 98%;
    padding-top: 10px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  &__row {
    &--full {
      width: 100%;
    }

    &--half {
      width: calc(50% - 6px);
    }
  }

  &__row-wrapper {
    //@include alignedFlex(space-between);
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
